(function () {
  const Arrows = {
    prevArrow:
      "<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg width='7' height='12' viewBox='0 0 7 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6 11L0.999999 6L6 1' stroke='#2D2E2F' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
    nextArrow:
      "<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg width='7' height='12' viewBox='0 0 7 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 1L6 6L1 11' stroke='#2D2E2F' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
  };

  function initSlider($sliderWrapper) {
    const $slider = $sliderWrapper.find('[data-carousel-slider]');
    const slidesOptions = $slider.data('carousel-slider');
    const newJSON = {...slidesOptions, ...Arrows};
    $slider.slick(newJSON);

    if (window.innerWidth <= 750) {
      $slider.not('.slick-initialized').slick(newJSON).slick('slickFilter', ':not(.d-none)');
    }

    if ($sliderWrapper.attr('data-section-type')) {
      document.dispatchEvent(
        new Event(`swiper::${$sliderWrapper.attr('data-section-type')}::ready`)
      );
    }

    // display arrows navigation when more than number items in a row
    if ($slider.find('.slick-arrow').length === 0) {
      $sliderWrapper.find('.arrow-wrapper a').hide();
    } else {
      $sliderWrapper.find('.arrow-wrapper a').show();
    }
  }

  $('[data-carousel-slider-wrapper]').each(function () {
    const $this = $(this);

    const delayTime = parseInt($this.data('carousel-slider-delay')) || 0;
    if (delayTime > 0) $this.hide();

    setTimeout(function () {
      initSlider($this);
      if (delayTime > 0) $this.show();
    }, delayTime);
  });

  $('[data-carousel-prev]').on('click', function () {
    const $this = $(this).data('carousel-prev');
    const slider = $(`[data-slider="${$this}"]`);

    slider.find('.slick-prev').trigger('click');
  });

  $('[data-carousel-next]').on('click', function () {
    const $this = $(this).data('carousel-next');
    const slider = $(`[data-slider="${$this}"]`);

    slider.find('.slick-next').trigger('click');
  });
})();
